import isEmpty from 'lodash-es/isEmpty'

import {
  ProfileBuildingsWidgetItem,
  ProfileFlatsWidgetItem,
  ProfileUsersWidgetItem,
} from '../../../Widget'
import { EMAIL_PROFILE_WIDGET_COPIED_TO_LIST_TYPE } from '../EmailProfileWidget.constants'
import { EmailProfileWidgetCopiedToItem } from '../EmailProfileWidgetCopiedToItem'

import ProviderIcon from '../../../../icons/provider.svg'

export function getUserListItemProps(value) {
  return {
    isArchived: value.archived,
    value,
  }
}

// #TODO Finish implementation after add data to API
export function getBuildingListItemProps(value) {
  return {
    isArchived: value.archived,
    text: value.text,
    value: value.id,
  }
}

// #TODO Finish implementation after add data to API
export function getFlatListItemProps(value) {
  return {
    description: value.description,
    isArchived: value.archived,
    text: value.text,
    value: value.id,
  }
}

export function getEntityListProps({
  handleClickRemove,
  handleSubmitRemove,
  items,
  name,
  t,
}) {
  const commonUserItemProps = {
    Item: EmailProfileWidgetCopiedToItem,
    getItemPropsFromValue: getUserListItemProps,
    itemProps: {
      Component: ProfileUsersWidgetItem,
      onClickRemove: handleClickRemove,
      onSubmitRemove: handleSubmitRemove,
    },
  }

  switch (name) {
    case EMAIL_PROFILE_WIDGET_COPIED_TO_LIST_TYPE.inhabitants:
      return {
        ...commonUserItemProps,
        title: t('EmailProfile.CopiedToWidgetDwellersListTitleKey', {
          count: items?.length,
        }),
      }
    case EMAIL_PROFILE_WIDGET_COPIED_TO_LIST_TYPE.staff_members:
      return {
        ...commonUserItemProps,
        title: t('EmailProfile.CopiedToWidgetManagersListTitleKey', {
          count: items?.length,
        }),
      }

    case EMAIL_PROFILE_WIDGET_COPIED_TO_LIST_TYPE.contractors:
      return {
        ...commonUserItemProps,
        itemProps: {
          ...commonUserItemProps.itemProps,
          Icon: ProviderIcon,
        },
        title: t('EmailProfile.CopiedToWidgetContractorsListTitleKey', {
          count: items?.length,
        }),
      }
    case EMAIL_PROFILE_WIDGET_COPIED_TO_LIST_TYPE.external_contacts:
      return {
        ...commonUserItemProps,
        title: t('EmailProfile.CopiedToWidgetExternalContactsListTitleKey', {
          count: items?.length,
        }),
      }
    case EMAIL_PROFILE_WIDGET_COPIED_TO_LIST_TYPE.buildings:
      return {
        Item: EmailProfileWidgetCopiedToItem,
        getItemPropsFromValue: getBuildingListItemProps,
        itemProps: {
          Component: ProfileBuildingsWidgetItem,
        },
        title: t('EmailProfile.CopiedToWidgetBuildingsListTitleKey', {
          count: items?.length,
        }),
      }
    case EMAIL_PROFILE_WIDGET_COPIED_TO_LIST_TYPE.flats:
      return {
        Item: EmailProfileWidgetCopiedToItem,
        getItemPropsFromValue: getFlatListItemProps,
        itemProps: {
          Component: ProfileFlatsWidgetItem,
        },
        title: t('EmailProfile.CopiedToWidgetFlatsListTitleKey', {
          count: items?.length,
        }),
      }
  }
}

export function isItemsEmpty(items) {
  return items && Object.values(items).every(isEmpty)
}
